module.exports = __webpack_public_path__ + "875cc6c87cdfee547e5baf553e0568d2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/sp-landing-graphic.svg
// module id = 636
// module chunks = 0